import React from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import './input.css';

class SearchSelect extends React.Component {
    state = {
        focused: false
    };

    handleChange = (key, val) => {
        this.props.onChange && this.props.onChange(key, val);
    }
    setFocused = (e) => {
        this.setState({ focused: true });
    }
    setBlure = (e) => {
        this.setState({ focused: false });
    }
    render() {
        let { error, options, value, name, label, ...otherProps } = this.props;
        error = error === undefined ? '' : error;
        value = value === undefined ? '' : value;

        return (
            <div className="MuiFormControl-root MuiTextField-root" style={{marginTop: '15px'}}>
                {label !== null && <label style={{zIndex: 40}} className={`MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated ${this.state.focused || this.props.type === "date" ? "Mui-focused MuiInputLabel-shrink" : ""} ${value !== '' ? "MuiInputLabel-shrink" : ""} ${error !== '' && this.state.focused ? 'Mui-error' : ''}`} htmlFor={name}>{label}</label>}
                <div className={`MuiInputBase-root MuiInput-root MuiInput-underline MuiInputBase-formControl MuiInput-formControl ${this.state.focused ? "Mui-focused" : ""} ${error !== '' ? 'Mui-error' : ''}`}>
                    <Typeahead
						id={name}
						name={name}
						labelKey="name"
						multiple={false}
						flip={true}
						onChange={(e) => {this.handleChange(name, e)}}
						options={options}
						// placeholder={label}
						selected={value}
						className="pl-0 pr-0"
						onFocus={this.setFocused}
						onBlur={this.setBlure}
						inputProps={{ autoComplete: "new-password", className: "MuiInputBase-input MuiInput-input w-100", ...otherProps }}
					/>
                </div>
                {error !== '' && <p className="MuiFormHelperText-root Mui-error MuiFormHelperText-filled">{error}</p>}
            </div>
        );
    }
}

export default SearchSelect;